import { callable, computable, mix, observable, watch } from "@chorda/core";
import { Custom } from "../../../utils";
export const withInfiniteScroll = (props) => {
    const ioOptions = {
        rootMargin: '600px',
        threshold: 0
    };
    return mix({
        defaults: {
            infiniteScroll: () => observable({
                intersectionObserver: null,
                observableItems: new Map(),
                totalPages: 0,
                lastPage: 0,
                pages: [],
                loading: false
            }),
            onNextPage: () => callable(null),
        },
        injections: {
            infiniteItems: ({ infiniteScroll }) => computable(() => {
                let out = [];
                infiniteScroll.pages.forEach(page => {
                    page.items.forEach(itm => {
                        out.push(itm);
                    });
                });
                return out;
            })
        },
        joints: {
            initInfiniteScroll: ({ $dom, infiniteScroll, onNextPage }) => {
                const { lastPage, totalPages, loading, pages, resetAndGetFirst, update } = infiniteScroll;
                const callback = (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            if (lastPage < totalPages && loading != true) {
                                loading.$value = true;
                                onNextPage(lastPage + 1);
                            }
                        }
                    });
                };
                $dom.$subscribe((next, prev) => {
                    if (next) {
                        infiniteScroll.intersectionObserver.$value = new IntersectionObserver(callback, Object.assign(Object.assign({}, ioOptions), { root: next }));
                    }
                    else if (prev) {
                        infiniteScroll.intersectionObserver.disconnect();
                        infiniteScroll.intersectionObserver.$value = null;
                    }
                });
                resetAndGetFirst.$value = () => {
                    pages.$value = [];
                    totalPages.$value = 0;
                    lastPage.$value = 0;
                    loading.$value = true;
                    onNextPage(1);
                };
                update.$value = (id, items, total) => {
                    pages[id - 1].$value = { id, items };
                    totalPages.$value = total;
                    lastPage.$value = id;
                    loading.$value = false;
                };
            },
        },
        components: {
            infiniteTail: Custom({
                weight: 10,
                joints: {
                    subscribeObserver: ({ $dom, infiniteScroll: { intersectionObserver } }) => {
                        watch(() => {
                            if ($dom.$value && intersectionObserver.$value) {
                                intersectionObserver.observe($dom.$value);
                            }
                        }, [$dom, intersectionObserver]);
                    }
                }
            })
        }
    }, props);
};
